import styled from 'styled-components';
import { spacing, colors, Body2Bold, Body1 } from 'ui/theme';
import { OpenNewWindow16 } from 'ui/icons';

export const ListTitleBar = styled.div`
  padding-bottom: ${spacing.plusHalf};
  display: flex;
  justify-content: space-between;
`;

export const ListTitle = styled(Body1)`
  margin-top: 0;
  margin-bottom: 0;
`;

export const SelectedListInfo = styled(Body2Bold)`
  color: ${colors.positive100};
  margin-top: 0;
  margin-bottom: 0;
`;

export const StyledOpenNewWindow16 = styled(OpenNewWindow16)`
  margin-right: ${spacing.half};
`;

export const TableHeaderBar = styled.div`
  display: flex;
  align-items: center;
`;
